import { Box, Button, ButtonRow, Text } from '@ksyos/design-system';
import { useNavigate, useParams } from '@ksyos/router';
import { ServiceCode } from '../../../../common/enums/ServiceCode';
import { useQuestionnairesProgress } from '../../../utils/hooks/useQuestionnairesProgress';
import { CustomContainer } from '../../elements/molecules/customContainer/CustomContainer';
import { Main } from '../../elements/molecules/main/Main';
import { Header } from '../../elements/organisms/header/Header';
import { PageWrapper } from '../../elements/organisms/pageWrapper/PageWrapper';
import { CompleteQuestionnaireList } from './components/CompleteQuestionnaireList';

export function QuestionnairesSuccess() {
    const params = useParams();
    const navigate = useNavigate();

    const { availableQuestionnaireActions } = useQuestionnairesProgress(ServiceCode.OSAS);

    const questionnaireName = decodeURIComponent(params.questionnaireName as string);

    const isLifestyleQuestionnaire = questionnaireName === 'BMI & alcoholconsumptie';

    let message = 'Je hebt alle vragenlijsten ingevuld en verstuurd';

    if (availableQuestionnaireActions.length !== 0) {
        message = isLifestyleQuestionnaire
            ? 'De paar extra vragen zijn afgerond en verzonden'
            : `Je hebt de vragenlijst ingevuld en verstuurd`;
    }

    return (
        <PageWrapper fullHeight>
            <Header
                backButtonText=" "
                backUrl="/osas/questionnaires/"
                hasBackbutton
            />
            <Main>
                <CustomContainer>
                    <Box
                        alignItems="center"
                        backgroundColor={'white'}
                        display="flex"
                        flexDirection="column"
                        gap={4}
                        padding={8}
                    >
                        <img
                            alt={'questionnaire afgerond'}
                            src="/assets/images/somnology/questionnaires/questionnaire-afronden-success.svg"
                            style={{ width: '154px' }}
                        />

                        <Text
                            fontWeight="medium"
                            size="2xl"
                        >
                            {message}
                        </Text>

                        {availableQuestionnaireActions.length === 0 && (
                            <Text
                                fontWeight="normal"
                                size="md"
                            >
                                Als wij de resultaten van jouw onderzoek binnen hebben, sturen wij jou een e-mail. Via
                                deze mail kan je een video-afspraak maken met onze slaaparts.
                            </Text>
                        )}

                        <Box
                            display="flex"
                            flexDirection={'column'}
                            gap={4}
                            width="100%"
                        >
                            <CompleteQuestionnaireList hasBoxShadow={false} />
                        </Box>

                        <Box width="100%">
                            <ButtonRow
                                isStackedBelowSmall={true}
                                justify="right"
                            >
                                <Button
                                    color="secondary"
                                    onClick={goToHome}
                                    variant={availableQuestionnaireActions.length > 0 ? 'outline' : 'solid'}
                                >
                                    Ga terug naar home
                                </Button>

                                {availableQuestionnaireActions.length > 0 && (
                                    <Button
                                        color="secondary"
                                        onClick={goToNextQuestionnaire}
                                        variant="solid"
                                    >
                                        Ga naar volgende vragenlijst
                                    </Button>
                                )}
                            </ButtonRow>
                        </Box>
                    </Box>
                </CustomContainer>
            </Main>
        </PageWrapper>
    );

    function goToNextQuestionnaire() {
        const nextAction = availableQuestionnaireActions[0];

        if (nextAction) {
            navigate(
                `/osas/${nextAction.name === 'BMI & alcoholconsumptie' ? 'lifestyleQuestionnaire' : 'questionnaires'}/${nextAction.id}`
            );
        }
    }

    function goToHome() {
        navigate('/');
    }
}
